export enum ConfigurationType {
  Label = 'label',
  CallingGroup = 'calling-group',
  VoiceMessage = 'voice-message',
}
